import { getErrorFromErrorResponse, isErrorResponse } from '@standardnotes/responses';
import { AbstractService } from '../Service/AbstractService';
export class RevisionManager extends AbstractService {
    constructor(revisionApiService, internalEventBus) {
        super(internalEventBus);
        this.revisionApiService = revisionApiService;
        this.internalEventBus = internalEventBus;
    }
    async listRevisions(itemUuid) {
        const result = await this.revisionApiService.listRevisions(itemUuid.value);
        if (isErrorResponse(result)) {
            throw new Error(getErrorFromErrorResponse(result).message);
        }
        return result.data.revisions;
    }
    async deleteRevision(itemUuid, revisionUuid) {
        const result = await this.revisionApiService.deleteRevision(itemUuid.value, revisionUuid.value);
        if (isErrorResponse(result)) {
            throw new Error(getErrorFromErrorResponse(result).message);
        }
        return result.data.message;
    }
    async getRevision(itemUuid, revisionUuid) {
        const result = await this.revisionApiService.getRevision(itemUuid.value, revisionUuid.value);
        if (isErrorResponse(result)) {
            throw new Error(getErrorFromErrorResponse(result).message);
        }
        return result.data.revision;
    }
}
